import { useCallback, useMemo } from 'react';
import { useUserData } from 'core/Api';
import usePlatformService from '../../hooks/usePlatformService';

export const useAffiliateLink = (merchant: null | { wildfire_id?: string; url: string }) => {
  const { data: user } = useUserData(); // TODO - This needs to only select the user uuid. Also this should be generally fixed
  const Platform = usePlatformService();
  const deviceID = '10270859';

  const url = useMemo(() => {
    const protocol = Platform.mobileBrowser == 'ios' ? 'http' : 'https';
    if (merchant?.wildfire_id && user?.uuid) {
      return `${protocol}://wild.link/e?c=${merchant.wildfire_id}&d=${deviceID}&tc=${user.uuid}`;
    }
    return merchant?.url;
  }, [merchant]);

  const navigate = useCallback(() => {
    window.open(url, '_blank', '');
  }, [url]);

  return { url, navigate };
};
